/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

// clang-format off
export {
  defineBase as ÉµdefineBase,
  defineComponent as ÉµdefineComponent,
  defineDirective as ÉµdefineDirective,
  definePipe as ÉµdefinePipe,
  defineNgModule as ÉµdefineNgModule,
  detectChanges as ÉµdetectChanges,
  renderComponent as ÉµrenderComponent,
  ComponentType as ÉµComponentType,
  ComponentFactory as ÉµRender3ComponentFactory,
  ComponentRef as ÉµRender3ComponentRef,
  DirectiveType as ÉµDirectiveType,
  RenderFlags as ÉµRenderFlags,
  directiveInject as ÉµdirectiveInject,
  injectAttribute as ÉµinjectAttribute,
  getFactoryOf as ÉµgetFactoryOf,
  getInheritedFactory as ÉµgetInheritedFactory,
  templateRefExtractor as ÉµtemplateRefExtractor,
  PublicFeature as ÉµPublicFeature,
  InheritDefinitionFeature as ÉµInheritDefinitionFeature,
  NgOnChangesFeature as ÉµNgOnChangesFeature,
  NgModuleType as ÉµNgModuleType,
  NgModuleRef as ÉµRender3NgModuleRef,
  CssSelectorList as ÉµCssSelectorList,
  markDirty as ÉµmarkDirty,
  NgModuleFactory as ÉµNgModuleFactory,
  NO_CHANGE as ÉµNO_CHANGE,
  container as Éµcontainer,
  nextContext as ÉµnextContext,
  elementStart as ÉµelementStart,
  namespaceHTML as ÉµnamespaceHTML,
  namespaceMathML as ÉµnamespaceMathML,
  namespaceSVG as ÉµnamespaceSVG,
  element as Éµelement,
  listener as Éµlistener,
  text as Éµtext,
  embeddedViewStart as ÉµembeddedViewStart,
  query as Éµquery,
  registerContentQuery as ÉµregisterContentQuery,
  projection as Éµprojection,
  bind as Éµbind,
  interpolation1 as Éµinterpolation1,
  interpolation2 as Éµinterpolation2,
  interpolation3 as Éµinterpolation3,
  interpolation4 as Éµinterpolation4,
  interpolation5 as Éµinterpolation5,
  interpolation6 as Éµinterpolation6,
  interpolation7 as Éµinterpolation7,
  interpolation8 as Éµinterpolation8,
  interpolationV as ÉµinterpolationV,
  pipeBind1 as ÉµpipeBind1,
  pipeBind2 as ÉµpipeBind2,
  pipeBind3 as ÉµpipeBind3,
  pipeBind4 as ÉµpipeBind4,
  pipeBindV as ÉµpipeBindV,
  pureFunction0 as ÉµpureFunction0,
  pureFunction1 as ÉµpureFunction1,
  pureFunction2 as ÉµpureFunction2,
  pureFunction3 as ÉµpureFunction3,
  pureFunction4 as ÉµpureFunction4,
  pureFunction5 as ÉµpureFunction5,
  pureFunction6 as ÉµpureFunction6,
  pureFunction7 as ÉµpureFunction7,
  pureFunction8 as ÉµpureFunction8,
  pureFunctionV as ÉµpureFunctionV,
  getCurrentView as ÉµgetCurrentView,
  restoreView as ÉµrestoreView,
  containerRefreshStart as ÉµcontainerRefreshStart,
  containerRefreshEnd as ÉµcontainerRefreshEnd,
  queryRefresh as ÉµqueryRefresh,
  loadQueryList as ÉµloadQueryList,
  elementEnd as ÉµelementEnd,
  elementProperty as ÉµelementProperty,
  projectionDef as ÉµprojectionDef,
  reference as Éµreference,
  enableBindings as ÉµenableBindings,
  disableBindings as ÉµdisableBindings,
  elementAttribute as ÉµelementAttribute,
  elementStyling as ÉµelementStyling,
  elementStylingMap as ÉµelementStylingMap,
  elementStyleProp as ÉµelementStyleProp,
  elementStylingApply as ÉµelementStylingApply,
  elementClassProp as ÉµelementClassProp,
  textBinding as ÉµtextBinding,
  template as Éµtemplate,
  embeddedViewEnd as ÉµembeddedViewEnd,
  store as Éµstore,
  load as Éµload,
  pipe as Éµpipe,
  BaseDef as ÉµBaseDef,
  ComponentDef as ÉµComponentDef,
  ComponentDefWithMeta as ÉµComponentDefWithMeta,
  DirectiveDef as ÉµDirectiveDef,
  DirectiveDefWithMeta as ÉµDirectiveDefWithMeta,
  PipeDef as ÉµPipeDef,
  PipeDefWithMeta as ÉµPipeDefWithMeta,
  whenRendered as ÉµwhenRendered,
  i18nAttribute as Éµi18nAttribute,
  i18nExp as Éµi18nExp,
  i18nStart as Éµi18nStart,
  i18nEnd as Éµi18nEnd,
  i18nApply as Éµi18nApply,
  i18nExpMapping as Éµi18nExpMapping,
  i18nInterpolation1 as Éµi18nInterpolation1,
  i18nInterpolation2 as Éµi18nInterpolation2,
  i18nInterpolation3 as Éµi18nInterpolation3,
  i18nInterpolation4 as Éµi18nInterpolation4,
  i18nInterpolation5 as Éµi18nInterpolation5,
  i18nInterpolation6 as Éµi18nInterpolation6,
  i18nInterpolation7 as Éµi18nInterpolation7,
  i18nInterpolation8 as Éµi18nInterpolation8,
  i18nInterpolationV as Éµi18nInterpolationV,
  i18nMapping as Éµi18nMapping,
  I18nInstruction as ÉµI18nInstruction,
  I18nExpInstruction as ÉµI18nExpInstruction,
  WRAP_RENDERER_FACTORY2 as ÉµWRAP_RENDERER_FACTORY2
} from './render3/index';

export {  Render3DebugRendererFactory2 as ÉµRender3DebugRendererFactory2 } from './render3/debug';


export {
  R3_COMPILE_NGMODULE_DEFS as ÉµcompileNgModuleDefs,
  R3_PATCH_COMPONENT_DEF_WTIH_SCOPE as ÉµpatchComponentDefWithScope,
  R3_COMPILE_COMPONENT as ÉµcompileComponent,
  R3_COMPILE_DIRECTIVE as ÉµcompileDirective,
  R3_COMPILE_PIPE as ÉµcompilePipe,
} from './ivy_switch/compiler/ivy_switch_on';

export {
  NgModuleDef as ÉµNgModuleDef,
  NgModuleDefWithMeta as ÉµNgModuleDefWithMeta,
  NgModuleTransitiveScopes as ÉµNgModuleTransitiveScopes,
} from './metadata/ng_module';

export {
  sanitizeHtml as ÉµsanitizeHtml,
  sanitizeStyle as ÉµsanitizeStyle,
  sanitizeUrl as ÉµsanitizeUrl,
  sanitizeResourceUrl as ÉµsanitizeResourceUrl,
} from './sanitization/sanitization';

export {
  bypassSanitizationTrustHtml as ÉµbypassSanitizationTrustHtml,
  bypassSanitizationTrustStyle as ÉµbypassSanitizationTrustStyle,
  bypassSanitizationTrustScript as ÉµbypassSanitizationTrustScript,
  bypassSanitizationTrustUrl as ÉµbypassSanitizationTrustUrl,
  bypassSanitizationTrustResourceUrl as ÉµbypassSanitizationTrustResourceUrl,
} from './sanitization/bypass';

export {
  getContext as ÉµgetContext
} from './render3/context_discovery';

export {
  Player as ÉµPlayer,
  PlayState as ÉµPlayState,
  PlayerHandler as ÉµPlayerHandler,
} from './render3/interfaces/player';

export {
  LContext as ÉµLContext,
} from './render3/interfaces/context';

export {
  addPlayer as ÉµaddPlayer,
  getPlayers as ÉµgetPlayers,
} from './render3/player';

// we reexport these symbols just so that they are retained during the dead code elimination
// performed by rollup while it's creating fesm files.
//
// no code actually imports these symbols from the @angular/core entry point
export {
  compileNgModuleFactory__POST_NGCC__ as ÉµcompileNgModuleFactory__POST_NGCC__
} from './application_ref';
export {
  R3_COMPILE_COMPONENT__POST_NGCC__ as ÉµR3_COMPILE_COMPONENT__POST_NGCC__,
  R3_COMPILE_DIRECTIVE__POST_NGCC__ as ÉµR3_COMPILE_DIRECTIVE__POST_NGCC__,
  R3_COMPILE_INJECTABLE__POST_NGCC__ as ÉµR3_COMPILE_INJECTABLE__POST_NGCC__,
  R3_COMPILE_NGMODULE__POST_NGCC__ as ÉµR3_COMPILE_NGMODULE__POST_NGCC__,
  R3_COMPILE_PIPE__POST_NGCC__ as ÉµR3_COMPILE_PIPE__POST_NGCC__,
  ivyEnable__POST_NGCC__ as ÉµivyEnable__POST_NGCC__,
} from './ivy_switch/compiler/legacy';

export {
  R3_ELEMENT_REF_FACTORY__POST_NGCC__ as ÉµR3_ELEMENT_REF_FACTORY__POST_NGCC__,
  R3_TEMPLATE_REF_FACTORY__POST_NGCC__ as ÉµR3_TEMPLATE_REF_FACTORY__POST_NGCC__,
  R3_CHANGE_DETECTOR_REF_FACTORY__POST_NGCC__ as ÉµR3_CHANGE_DETECTOR_REF_FACTORY__POST_NGCC__,
  R3_VIEW_CONTAINER_REF_FACTORY__POST_NGCC__ as ÉµR3_VIEW_CONTAINER_REF_FACTORY__POST_NGCC__,
  R3_RENDERER2_FACTORY__POST_NGCC__ as ÉµR3_RENDERER2_FACTORY__POST_NGCC__,
} from './ivy_switch/runtime/legacy';


// clang-format on
